import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './MainCollections.scss';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import config from '../../config';
import { useHistory, NavLink } from 'react-router-dom';
import Marquee from 'react-fast-marquee';

const MainCollections = (props) => {
  const { curLang, data, pageTitle } = props;

  // const pageTitle = {
  //   sc: '时装系列',
  //   en: 'COLLECTIONS',
  //   tc: '時裝系列',
  // };

  return (
    <section className="main-collections">
      <PageTitle title={pageTitle} link={`${config.routePathTo}/${curLang}/collections`} />
      <Marquee speed={50} className="collections-marquee">
        {data?.map((item, index) => (
          <div className="card-container" key={index}>
            <NavLink
              to={(location) => ({
                ...location,
                pathname: `${config.routePathTo}/${curLang}/collections/${item.metadata.id}`,
                search: `?p1=${item.collection.season}&p2=${item.collection.brand}&ref_source=fashionally_home_collection`,
              })}
            >
              <img src={item.collection.thumbnail_upload} alt="error" />
              <div className="card-overlay">
                <div className="card-overlay-text">
                  <div className="title">{item[curLang].collection_detail.collection_title}</div>
                  <div className="designer">{item.collection.brand}</div>
                </div>
              </div>
            </NavLink>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default MainCollections;
